import composeStore from '../store/composeStore';
import ComposeViewState from '../store/schema/ComposeViewState';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isSmimeEnabledInViewState from 'owa-smime/lib/utils/isSmimeEnabledInViewState';
import { select } from 'satcheljs/lib/legacy';

export interface ShouldUseAsyncSendState {
    pendingViewState: ComposeViewState;
    asyncSendEnabled: boolean;
    hasFloatingViewState: boolean;
}

export default select<ShouldUseAsyncSendState>({
    pendingViewState: () => composeStore.viewStates.get(composeStore.pendingComposeId),
    hasFloatingViewState: () => composeStore.floatingViewStates.size > 0,
    asyncSendEnabled: () => getUserConfiguration().AsyncSendEnabled,
})(function shouldUseAsyncSend(viewState: ComposeViewState, state?: ShouldUseAsyncSendState) {
    return (
        state.asyncSendEnabled &&
        !state.pendingViewState &&
        !state.hasFloatingViewState &&
        viewState.preferAsyncSend &&
        !viewState.isPopout && //Popout behavior needs sync send in order to close the window when the message is sent.
        !isSmimeEnabledInViewState(viewState.smimeViewState) //Smime message needs a sync send, because it needs user interaction before sending message.
    );
});
